module.exports = __webpack_public_path__ + "img/Biology.4ce5642e.svg";